<template>
  <div class="compare">
    <div class="compare__left">
      <div class="compare__leftInner">
        <div class="compare__title">{{ leftTitle }}</div>
        <div v-for="(item, index) in leftItems" :key="`left-${index}`" class="compare__item">
          <span class="compare__txt compare__txt--del">{{ item }}</span>
          <img class="compare__statusIcon" :src="closeIcon" alt="">
        </div>
      </div>
    </div>
    <div class="compare__right">
      <div class="compare__rightBg" :style="{ backgroundImage: `url(${rightBg})` }"></div>
      <div class="compare__rightInner">
        <div class="compare__title compare__title--light">{{ rightTitle }}</div>
        <div v-for="(item, index) in rightItems" :key="`right-${index}`" class="compare__item compare__item--light">
          <span class="compare__arrow">→</span>
          <span class="compare__txt">{{ item }}</span>
          <img class="compare__statusIcon" :src="openIcon" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparePanel',
  props: {
    leftTitle: {
      type: String,
      default: '传统招聘'
    },
    rightTitle: {
      type: String,
      default: '悬赏招聘'
    },
    leftItems: {
      type: Array,
      default: () => []
    },
    rightItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      closeIcon: 'https://file.zmxs.com.cn/img/2026-09-02140131.png',
      openIcon: 'https://file.zmxs.com.cn/img/2026-09-02140132.png',
      rightBg: 'https://file.zmxs.com.cn/img/2026-09-02140133.png'
    }
  }
}
</script>

<style lang="less" scoped>
.compare {
  position: relative;
  width: 1200px;
  margin: 85px auto 0;
  display: flex;
  align-items: center;
  z-index: 2;

  &__left {
    position: relative;
    width: 631px;
    height: 359px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    border-radius: 32px;
    border: 1px solid #D8CBFF;
    box-shadow: 0 24px 60px -30px rgba(107, 58, 255, 0.18);
  }

  &__leftInner {
    padding: 52px 100px;
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  &__title {
    margin-bottom: 27px;
    font-size: 24px;
    font-weight: 600;
    color: #6E7494;

    &--light {
      padding-left: 14px;
      margin-bottom: 32px;
      font-size: 32px;
      font-weight: 700;
      letter-spacing: 0.5px;
      color: #ffffff;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 50px;
    font-size: 20px;
    font-weight: 600;
    color: #6E7494;

    &--light {
      gap: 24px;
      padding: 11px 0;
      font-size: 20px;
      color: #ffffff;
      border-bottom: 1px solid rgba(255, 255, 255, 0.14);

      &:last-child {
        border-bottom: none;
      }
    }
  }

  &__txt {
    flex: 1 1 auto;

    &--del {
      text-decoration: line-through;
      text-decoration-color: #6E7494;
      text-decoration-thickness: 2px;
    }
  }

  &__arrow {
    flex-shrink: 0;
    font-size: 22px;
    color: rgba(230, 214, 255, 0.95);
    transform: translateY(-1px);
  }

  &__statusIcon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &__right {
    position: relative;
    width: 591px;
    height: 402px;
    margin-top: -10px;
    margin-left: -22px;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 32px;
    box-shadow: 0 38px 80px -30px rgba(107, 58, 255, 0.58);
  }

  &__rightBg {
    position: absolute;
    inset: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 591px 402px;
  }

  &__rightInner {
    position: relative;
    z-index: 1;
    padding: 67px 79px 0 64px;
  }
}
</style>
